import { FleetBalenaDeviceDto } from '@mi-front/api-v2';
import { Chip } from '@mui/material';
import { defineMessage, MessageDescriptor, useIntl } from 'react-intl';

const streamBoxMessage = defineMessage({
  id: 'fleet.devices.type.streamBox',
  defaultMessage: 'StreamBox',
});

const airnodeMessage = defineMessage({
  id: 'fleet.devices.type.airnode',
  defaultMessage: 'AirNode',
});

const typeMessages: Record<string, MessageDescriptor> = {
  'streamer-box': streamBoxMessage,
  /** Alias if backend renames the enum value before OpenAPI is regenerated. */
  'stream-box': streamBoxMessage,
  airnode: airnodeMessage,
};

/**
 * Resolves the i18n label for a Balena device type, with a safe fallback.
 */
function getTypeMessage(
  type: FleetBalenaDeviceDto['type'] | string | undefined,
): MessageDescriptor {
  if (type && typeMessages[type]) {
    return typeMessages[type];
  }

  // Fallback keeps the list usable when the API sends an unexpected type.
  return streamBoxMessage;
}

/**
 * Device type chip overlaid on the card map thumbnail.
 */
export function BalenaDeviceTypeChip({ type }: { type: FleetBalenaDeviceDto['type'] }) {
  const { $t } = useIntl();

  return (
    <Chip
      size="small"
      color={type === 'airnode' ? 'warning' : 'primary'}
      variant="filled"
      label={$t(getTypeMessage(type))}
      sx={{
        typography: 'caption',
        fontWeight: 500,
        height: 24,
        boxShadow: 1,
      }}
    />
  );
}
